/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPropertyRequest
 */
export interface APIPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPropertyRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIPropertyRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof APIPropertyRequest
     */
    type: string;
}

/**
 * Check if a given object implements the APIPropertyRequest interface.
 */
export function instanceOfAPIPropertyRequest(value: object): value is APIPropertyRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function APIPropertyRequestFromJSON(json: any): APIPropertyRequest {
    return APIPropertyRequestFromJSONTyped(json, false);
}

export function APIPropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'type': json['type'],
    };
}

export function APIPropertyRequestToJSON(value?: APIPropertyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
        'type': value['type'],
    };
}

